export function hasHitPlanLimitForCtas(numberOfCtasUsed = 0, numberOfMaxCtas = 999999999): boolean {
    return numberOfCtasUsed >= numberOfMaxCtas;
}
